














































































































import { Component, Vue, Mixins } from 'vue-property-decorator'
import Visualization from '../../mixins/Visualization.vue'

@Component
export default class Table extends Mixins(Visualization) {
  /**
   * Active.
   */
  public active: boolean[] | boolean[][] = []

  /**
   * Check if the current data is a radio or a checkbox question.
   */
  get isRadio() {
    return this.options.title && this.options.title.display
  }

  /**
   * Has multiple heading levels.
   */
  get hasMultipleHeadingLevels() {
    return this.isBoolean
      ? false
      : this.data.datasets.find(d => d.data.some(d => Array.isArray(d)))
  }

  /**
   * Check if the current data is boolean (yes/no)
   */
  get isBoolean() {
    return !this.data.labels
  }

  /**
   * On created hook.
   */
  created() {
    if (this.data.labels && !this.data.labels.includes('Missing data')) {
      const datasetsWithNoData = this.data.datasets.filter(d =>
        d.data.every(v => v === null)
      )
      if (datasetsWithNoData.length > 0) {
        this.data.labels.push('Missing data')
        //@ts-ignore
        this.options.labels.push('Missing data')
        //@ts-ignore
        datasetsWithNoData.forEach(d => d.data.push('Yes'))
      }
    }

    const maxLength = this.isBoolean
      ? 1
      : Math.max(...this.data.datasets.map(d => d.data.length))
    this.data.datasets.forEach((dataset, datasetIndex) => {
      if (this.isBoolean) {
        ;(this.active as boolean[]).push(false)
      } else {
        ;(this.active as boolean[][]).push(new Array(maxLength).fill(false))
      }
    })
  }

  /**
   * On mounted hook.
   */
  mounted() {
    let i = 0

    this.active.forEach((value, datasetIndex) => {
      if (Array.isArray(value)) {
        value.forEach((value, dataIndex) => {
          setTimeout(() => {
            this.$set(
              (this.active as boolean[][])[datasetIndex],
              dataIndex,
              true
            )
          }, 500 * (datasetIndex + 1) + i * 250)
          //@ts-ignore
          if (this.options.displayUntruthy !== false || value === 'Yes') {
            i++
          }
        })
      } else {
        setTimeout(() => {
          this.$set(this.active, datasetIndex, true)
        }, 500 * (datasetIndex + 1) + i * 250)
      }
    })
  }

  public getColor(index) {
    return this.getGroup(index) ? this.getGroup(index).color : null
  }

  public getGroup(index) {
    // @ts-ignore
    if (this.options.groups) {
      // @ts-ignore
      return this.options.groups.find(g => g.dataIndexes.includes(index))
    }
  }
}
